import { Button, Flex, Text } from '@servicetitan/anvil2';
import { formatCurrency } from '@servicetitan/financing-utils-shared';
import { LoanApplicationRead } from '@servicetitan/financing-api-client';

export interface TechnicianLoanBannerProps {
    loan: LoanApplicationRead;
    onContinueClick: () => Promise<void>;
    loading?: boolean;
}

export const TechnicianLoanBanner = ({
    loan,
    onContinueClick,
    loading = false,
}: TechnicianLoanBannerProps) => {
    const approvedAmount = loan.approvedAmount ?? 0;

    return (
        <Flex
            direction="column"
            gap="2"
            alignItems="center"
            justifyContent="center"
            style={{ marginBottom: '1rem', backgroundColor: '#E0F2FF', padding: '1rem' }}
        >
            <Text style={{ marginBottom: '0.5rem' }}>
                You're approved for up to {formatCurrency(approvedAmount)}
            </Text>
            <Button appearance="secondary" onClick={onContinueClick} loading={loading}>
                Continue With Offer
            </Button>
        </Flex>
    );
};
